export class paymentNsc {                
    "mobileNumber": any;
    "password" : string; 
    "status" : string;   
   }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/paymentNsc/paymentNsc.ts